import React from "react";
import {
  FaRegLightbulb,
  FaRegBuilding,
  FaRegHandshake,
  FaRegSmile,
} from "react-icons/fa";
import "./HowItWorks.css";

const steps = [
  {
    id: 1,
    icon: <FaRegLightbulb />,
    title: "Land Selection & Planning",
    description:
      "We carefully select prime locations and create comprehensive architectural blueprints for modern living.",
  },
  {
    id: 2,
    icon: <FaRegBuilding />,
    title: "Quality Construction",
    description:
      "Our skilled engineers execute modern designs using premium materials and sustainable building techniques.",
  },
  {
    id: 3,
    icon: <FaRegHandshake />,
    title: "Transparent Legal Dealings",
    description:
      "We ensure hassle-free paperwork, clear property ownership, and seamless financial processing for peace of mind.",
  },
  {
    id: 4,
    icon: <FaRegSmile />,
    title: "Timely Handover & Support",
    description:
      "Delivering your dream property on schedule with dedicated post-handover customer support.",
  },
];

const HowItWorks = () => {
  return (
    <section className="how-it-works">
      <div className="custom-container">
        <h2>
          HOW ICONIC <span className="styleTitle">GREENLAND WORKS</span>
        </h2>
        <p className="subtitle">
          A professional workflow designed to deliver excellence across all
          sectors
        </p>

        <div className="steps">
          {steps.map((step) => (
            <div className="step" key={step.id}>
              <div className="icon">{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
